import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMaintenance } from '../contexts/MaintenanceContext';

// Story 73 — full-screen takeover rendered by App.js whenever
// MaintenanceContext reports the backend unreachable. Cream (#F5EAD8) is
// sampled directly from maintenance-illustration.png's background so there's
// no seam around the art; it's also the marketing site's --color-bg token.
function MaintenancePage() {
  const { t } = useTranslation('maintenance');
  const { checking, retryNow } = useMaintenance();

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 py-10"
      style={{ backgroundColor: '#F5EAD8' }}
    >
      <div className="w-full max-w-sm flex flex-col items-center text-center">
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-6">
          <span style={{ color: '#085041' }}>Bento</span>
          <span className="text-orange-600">Ping</span>
        </h1>

        <img
          src="/assets/maintenance-illustration.png"
          alt=""
          className="w-48 sm:w-64 mb-6"
        />

        <h2 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-2">
          {t('headline')}
        </h2>
        <p className="text-sm sm:text-base text-gray-600 mb-8">
          {t('subtext')}
        </p>

        <button
          onClick={retryNow}
          disabled={checking}
          className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-orange-500 to-amber-600 px-5 py-2.5 text-sm font-semibold text-white shadow-md shadow-orange-200 transition hover:from-orange-600 hover:to-amber-700 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2 disabled:opacity-70"
        >
          {checking && (
            <svg className="w-4 h-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8v4a4 4 0 0 0-4 4H4z" />
            </svg>
          )}
          {checking ? t('checking') : t('retryButton')}
        </button>
      </div>
    </div>
  );
}

export default MaintenancePage;
